import { Reducer } from "redux";

import { NPPESDataResponse } from "../models/Api/PhysicianDetails";
import { nppesInitialRecord } from "../constants/PhysicianDetails";
import { GetPrimaryNPPESDataActionDispatchTypes } from "../constants/Nppes";
import { PrimaryNppesSearchDispatchTypes } from "../models/DispatchTypes/Nppes";

const initialState: NPPESDataResponse = {
  loading: true,
  response: nppesInitialRecord
};

const NppesPrimaryDetailsListReducer: Reducer<
NPPESDataResponse,
PrimaryNppesSearchDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case GetPrimaryNPPESDataActionDispatchTypes.GET_PRIMARY_NPPES_DATA_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case GetPrimaryNPPESDataActionDispatchTypes.GET_PRIMARY_NPPES_DATA_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case GetPrimaryNPPESDataActionDispatchTypes.GET_PRIMARY_NPPES_DATA_RESET: {
      return initialState;
    }
    case GetPrimaryNPPESDataActionDispatchTypes.GET_PRIMARY_NPPES_DATA_ERROR: {
      return initialState;
    }
  }
  return state;
};

export default NppesPrimaryDetailsListReducer;
